<template>
    <Page header="Курс" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-3 overflow-hidden">
                <div v-if="rate" class="surface-0 border-round-xl p-3 shadow-1">
                    <div class="flex justify-content-between align-items-start gap-3 flex-wrap">
                        <div class="flex flex-column gap-2">
                            <span class="text-xl font-semibold">{{ rate.from }} / {{ rate.to }}</span>
                            <span class="text-sm text-500">{{ rate.parse_type || '-' }}</span>
                        </div>
                        <div class="flex flex-column gap-1 text-right">
                            <span class="text-sm text-500">Последнее значение</span>
                            <span class="text-xl font-semibold">{{ rate.last_value || '-' }}</span>
                        </div>
                    </div>
                </div>

                <div class="surface-0 border-round-xl p-3 shadow-1">
                    <div class="grid">
                        <div class="col-12 md:col-4">
                            <label class="block text-sm text-500 mb-2">Дата от</label>
                            <DatePicker v-model="dateFromModel" showTime hourFormat="24" fluid />
                        </div>
                        <div class="col-12 md:col-4">
                            <label class="block text-sm text-500 mb-2">Дата до</label>
                            <DatePicker v-model="dateToModel" showTime hourFormat="24" fluid />
                        </div>
                        <div class="col-12 md:col-4 flex align-items-end">
                            <Button label="Обновить" icon="pi pi-sync" class="w-full" @click="reloadValues" :loading="loadingValues" />
                        </div>
                    </div>
                </div>

                <AdminRatesChart :chartData="chartData" :rate="rate" />

                <AdminRateValuesList
                    :values="values"
                    :totalRecords="valuesTotal"
                    :loading="loadingValues"
                    :defaultParams="lazyParams"
                    @lazyParams="setParams"
                />
            </div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/public/page.vue'
import AdminRatesChart from '@/components/admin/rates/chart.vue'
import AdminRateValuesList from '@/components/admin/rates/values_list.vue'

export default {
    components: {
        Page,
        AdminRatesChart,
        AdminRateValuesList,
    },
    data() {
        return {
            lazyParams: {
                rows: 20,
                first: 0,
                sortField: 'created_at',
                sortOrder: -1,
                // sort: { field: 'created_at', order: -1 },
                sort: {  },
            },
        }
    },
    computed: {
        rate() {
            return this.$store.getters.StateAdminSelectedRate
        },
        values() {
            return this.$store.getters.StateAdminRateValues || []
        },
        valuesTotal() {
            return this.$store.getters.StateAdminRateValuesTotal || 0
        },
        chartData() {
            return this.$store.getters.StateAdminRateChartData || { labels: [], datasets: [] }
        },
        loadingValues() {
            return this.$store.getters.StateAdminRatesLoadingValues
        },
        dateFromModel: {
            get() {
                const value = this.$store.getters.StateAdminRatesDateFrom
                return value ? new Date(value) : null
            },
            set(value) {
                this.$store.dispatch('ActionAdminSetRateDateRange', {
                    date_from: value ? value.toISOString() : null,
                    date_to: this.$store.getters.StateAdminRatesDateTo,
                })
            }
        },
        dateToModel: {
            get() {
                const value = this.$store.getters.StateAdminRatesDateTo
                return value ? new Date(value) : null
            },
            set(value) {
                this.$store.dispatch('ActionAdminSetRateDateRange', {
                    date_from: this.$store.getters.StateAdminRatesDateFrom,
                    date_to: value ? value.toISOString() : null,
                })
            }
        },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity, summary, detail, life: 3000 })
        },
        async ensureRate() {
            const routeId = this.$route.params.id
            if (this.rate && (this.rate._id === routeId || this.rate.id === routeId)) {
                return true
            }
            const result = await this.$store.dispatch('ActionAdminLoadRateById', routeId)
            if (!result.result) {
                this.showMess('error', 'Ошибка', 'Курс не найден')
            }
            return result.result
        },
        async loadValues() {
            const routeId = this.$route.params.id
            const result = await this.$store.dispatch('ActionAdminRateValuesList', {
                rate_id: routeId,
                limit: this.lazyParams.rows,
                skip: this.lazyParams.first,
                filter: {},
                sort: this.lazyParams.sort,
                date_from: this.$store.getters.StateAdminRatesDateFrom,
                date_to: this.$store.getters.StateAdminRatesDateTo,
            })
            if (!result.result) {
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке значений курса')
            }
        },
        async reloadValues() {
            this.lazyParams.first = 0
            await this.loadValues()
        },
        async setParams(params) {
            this.lazyParams = {
                ...this.lazyParams,
                ...params,
            }
            await this.loadValues()
        },
    },
    async mounted() {
        const hasRate = await this.ensureRate()
        if (hasRate) {
            await this.loadValues()
        }
    }
}
</script>